// src/features/cms/cmsThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCmsPageApi } from "../../api/userApi";

export const fetchCmsPage = createAsyncThunk(
  "cms/fetchCmsPage",
  async (key, { rejectWithValue }) => {
    try {
      const res = await getCmsPageApi(key);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to load CMS page");
    }
  }
);
